import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewFormOutput } = formModuleLenses

export default (state, { moduleId }) => viewFormOutput(moduleId, moduleDescriptions)
